var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (Object.prototype.hasOwnProperty.call(b, p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        if (typeof b !== "function" && b !== null)
            throw new TypeError("Class extends value " + String(b) + " is not a constructor or null");
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
var __spreadArray = (this && this.__spreadArray) || function (to, from) {
    for (var i = 0, il = from.length, j = to.length; i < il; i++, j++)
        to[j] = from[i];
    return to;
};
import * as React from 'react';
import { debounce } from '@material-ui/core';
import CarouselItem from './CarouselItem';
import CarouselWrapper from './CarouselWrapper';
import CarouselContentWrapper from './CarouselContentWrapper';
import CarouselController from './CarouselController';
var Carousel = /** @class */ (function (_super) {
    __extends(Carousel, _super);
    function Carousel(props) {
        var _this = _super.call(this, props) || this;
        _this.draggableElement = null;
        _this.wrapperElement = null;
        _this.itemsWrapperElement = null;
        _this.debouncedDimensionUpdate = null;
        _this.isDragging = false;
        _this.pointers = [];
        _this.distance = null;
        _this.lastDistance = null;
        _this.state = {
            dragging: {
                pointers: [],
                distance: null,
                lastDistance: null,
            },
            dimensions: {
                wrapperWidth: null,
                itemWidth: null,
            },
            activeItemId: null,
        };
        _this.handleWindowResize = _this.handleWindowResize.bind(_this);
        return _this;
    }
    Carousel.prototype.componentDidMount = function () {
        var _this = this;
        this.updateDimensions();
        this.debouncedDimensionUpdate = debounce(function () {
            _this.updateDimensions();
        }, 300);
        window.addEventListener('resize', this.handleWindowResize);
    };
    Carousel.prototype.componentWillUnmount = function () {
        window.removeEventListener('resize', this.handleWindowResize);
    };
    Carousel.prototype.componentDidUpdate = function (prevProps, prevState, snapshot) {
        // console.log('component did update', this.state.activeItemId, prevProps.activeItemId, this.props.activeItemId)
        if (this.state.activeItemId !== this.props.activeItemId) {
            this.setState({ activeItemId: this.props.activeItemId });
        }
    };
    Carousel.prototype.render = function () {
        var _this = this;
        var _a;
        return (React.createElement("div", { ref: function (element) { return _this.setDraggableElementRef(element); }, style: { touchAction: 'pan-y', userSelect: 'none', height: '100%', position: 'relative' }, onPointerDown: function (event) { return _this.handlePointerDown(event); }, onPointerMove: function (event) { return _this.handlePointerMove(event); }, onPointerUp: function (event) { return _this.handlePointerUp(event); }, onPointerCancel: function (event) { return _this.handlePointerUp(event); }, onPointerLeave: function (event) { return _this.handlePointerUp(event); } },
            this.props.enableController && this.renderController(),
            React.createElement(CarouselWrapper, { setRef: function (element) { return _this.wrapperElement = element; } },
                React.createElement(CarouselContentWrapper, { setRef: function (element) { return _this.itemsWrapperElement = element; }, style: this.getItemsWrapperStyle() }, (_a = this.props.items) === null || _a === void 0 ? void 0 : _a.map(function (item) {
                    var clickHandler = function () { return _this.handleClick(item); };
                    var isActive = _this.state.activeItemId === item.id;
                    return (React.createElement(CarouselItem, { key: item.id, isActive: isActive, clickHandler: clickHandler }, _this.props.renderItem(item)));
                })))));
    };
    Carousel.prototype.renderController = function () {
        var _this = this;
        return React.createElement(CarouselController, { items: this.props.items, activeItemId: this.state.activeItemId, updateActiveItem: function (item) { return _this.updateActiveItem(item); } });
    };
    Carousel.prototype.setDraggableElementRef = function (element) {
        if (this.draggableElement) {
            return;
        }
        this.draggableElement = element;
    };
    Carousel.prototype.handleWindowResize = function () {
        if (!this.debouncedDimensionUpdate) {
            return;
        }
        this.debouncedDimensionUpdate();
    };
    Carousel.prototype.handlePointerDown = function (event) {
        if (this.itemsWrapperElement) {
            this.itemsWrapperElement.classList.add('c-carousel--dragging');
        }
        this.lastDistance = this.distance = null;
        this.pointers = __spreadArray(__spreadArray([], this.pointers), [
            {
                id: event.pointerId,
                originalClientX: event.clientX,
                originalClientY: event.clientY,
            },
        ]);
        this.isDragging = true;
    };
    Carousel.prototype.handlePointerMove = function (event) {
        if (!this.isDragging) {
            return;
        }
        var originalEvent = this.pointers.find(function (item) { return item.id === event.pointerId; });
        if (!originalEvent) {
            return;
        }
        this.lastDistance = this.distance = event.clientX - originalEvent.originalClientX;
        if (!this.itemsWrapperElement) {
            return;
        }
        var left = this.getItemsWrapperLeft();
        this.itemsWrapperElement.style.transform = "translate(" + left + "px)";
    };
    Carousel.prototype.handlePointerUp = function (event) {
        event.stopPropagation();
        if (!this.isDragging) {
            return;
        }
        if (this.itemsWrapperElement) {
            this.itemsWrapperElement.classList.remove('c-carousel--dragging');
        }
        this.selectClosestItem();
        this.distance = null;
        this.pointers = [];
        this.isDragging = false;
        if (this.itemsWrapperElement) {
            var left = this.getItemsWrapperLeft();
            this.itemsWrapperElement.style.transform = "translate(" + left + "px)";
        }
    };
    Carousel.prototype.selectClosestItem = function () {
        var _a, _b, _c;
        if (!this.props.items) {
            return;
        }
        var left = this.getItemsWrapperLeft();
        var itemWidth = (_a = this.state.dimensions.itemWidth) !== null && _a !== void 0 ? _a : 1;
        var wrapperWidth = (_b = this.state.dimensions.wrapperWidth) !== null && _b !== void 0 ? _b : 0;
        var screenMiddle = wrapperWidth / 2;
        var itemsWrapperWidth = (_c = this.getItemsWrapperWidth()) !== null && _c !== void 0 ? _c : 0;
        // handle small movements that less than half ot an items width
        if (this.distance && Math.abs(this.distance) > 10 && Math.abs(this.distance) < itemWidth / 2) {
            var newItemIndex = null;
            var itemIds = this.props.items.map(function (item) { return item.id; });
            var activeItemIndex = itemIds.indexOf(this.state.activeItemId);
            if (this.distance < 0) {
                newItemIndex = Math.min(this.getItemsNumber() - 1, activeItemIndex + 1);
                this.updateActiveItem(this.props.items[newItemIndex]);
                return;
            }
            newItemIndex = Math.max(0, activeItemIndex - 1);
            this.updateActiveItem(this.props.items[newItemIndex]);
            return;
        }
        // pick first one
        if (left > screenMiddle) {
            this.updateActiveItem(this.props.items[0]);
            return;
        }
        var leftVisible = itemsWrapperWidth + left;
        // pick last one
        if (leftVisible < screenMiddle) {
            this.updateActiveItem(this.props.items[this.getItemsNumber() - 1]);
            return;
        }
        // pick the middle one
        var newItemNumber = Math.round((screenMiddle - left - itemWidth / 2) / itemWidth);
        this.updateActiveItem(this.props.items[newItemNumber]);
    };
    Carousel.prototype.handleClick = function (item) {
        if (this.lastDistance && Math.abs(this.lastDistance) > 10) {
            return;
        }
        this.updateActiveItem(item);
    };
    Carousel.prototype.updateActiveItem = function (item) {
        this.setState({ activeItemId: item.id });
        if (this.state.activeItemId === item.id) {
            return;
        }
        if (this.props.onChange) {
            this.props.onChange(item);
        }
    };
    Carousel.prototype.updateDimensions = function () {
        this.setState({
            dimensions: {
                wrapperWidth: this.getWrapperWidth(),
                itemWidth: this.getFirstItemWidth(),
            },
            activeItemId: this.props.activeItemId,
        });
    };
    Carousel.prototype.getItemsWrapperStyle = function () {
        var left = this.getItemsWrapperLeft();
        return {
            transform: "translate(" + left + "px)",
        };
    };
    Carousel.prototype.getItemsWrapperLeft = function () {
        var _a, _b;
        var wrapperWidth = this.state.dimensions.wrapperWidth;
        var itemWidth = this.state.dimensions.itemWidth;
        if (!wrapperWidth || !itemWidth) {
            return 0;
        }
        var activeItem = this.getActiveItem();
        var activeItemNumber = (_b = (_a = this.props.items) === null || _a === void 0 ? void 0 : _a.indexOf(activeItem)) !== null && _b !== void 0 ? _b : 0;
        var left = wrapperWidth / 2;
        left -= itemWidth / 2;
        if (activeItemNumber > 0) {
            left -= itemWidth * activeItemNumber;
        }
        if (this.distance) {
            left += this.distance;
        }
        return Math.round(left);
    };
    Carousel.prototype.getWrapperWidth = function () {
        if (!this.wrapperElement) {
            return null;
        }
        return this.wrapperElement.clientWidth;
    };
    Carousel.prototype.getItemsWrapperWidth = function () {
        if (!this.itemsWrapperElement) {
            return null;
        }
        return this.itemsWrapperElement.scrollWidth;
    };
    Carousel.prototype.getFirstItemWidth = function () {
        var itemElements = this.getItemElements();
        if (!itemElements) {
            return null;
        }
        var firstItem = itemElements.item(0);
        if (!firstItem) {
            return null;
        }
        return firstItem.clientWidth;
    };
    Carousel.prototype.getItemsNumber = function () {
        var _a, _b;
        return (_b = (_a = this.getItemElements()) === null || _a === void 0 ? void 0 : _a.length) !== null && _b !== void 0 ? _b : 0;
    };
    Carousel.prototype.getItemElements = function () {
        if (!this.itemsWrapperElement) {
            return null;
        }
        return this.itemsWrapperElement.childNodes;
    };
    Carousel.prototype.getActiveItem = function () {
        var _this = this;
        var _a;
        return (_a = this.props.items) === null || _a === void 0 ? void 0 : _a.find(function (item) { return item.id === _this.state.activeItemId; });
    };
    return Carousel;
}(React.Component));
export default Carousel;
